import useNotification from './useNotification';

const errorMessage = 'Something went wrong while downloading the report';

const useFileDownloader = () => {
    const { showErrorNotification } = useNotification();

    return async (fetchFunction, params = {}) => {
        try {
            const response = await fetchFunction(params);

            if (response.error) {
                showErrorNotification(response.error.customMessage ?? errorMessage);
                return;
            }

            const blob = new Blob([response.blob], {
                type: response.mimeType || 'application/octet-stream',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;

            const filename = response.filename;
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);
        } catch (_) {
            showErrorNotification(errorMessage);
        }
    };
};

export default useFileDownloader;
